/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import dashboardMaster from './dashboard-master'
// import appsAndPages from './apps-and-pages'
// import others from './others'
// import chartsAndMaps from './charts-and-maps'
// import uiElements from './ui-elements'
// import formAndTable from './forms-and-table'
import summary from './summary'
import accountAndMember from './account-and-member'
import security from './security'
import api from './api'
import settingLotto from './setting-lotto'
import report from './report'
import invoice from './invoice'
import fraudDetection from './fraud-detection'
import fraudDetectionSingle from './fraud-detection-single'
// import system from './system'

// Function to get nav items based on isMaster
// Fraud detection items are inserted after settingLotto (inside Lotto group)
export const getNavMenuItems = isMaster => [
  ...(isMaster ? dashboardMaster : dashboard),
  ...summary,
  ...invoice,
  ...accountAndMember,
  ...report,
  ...settingLotto,
  ...(isMaster ? fraudDetection : fraudDetectionSingle),
  ...security,
  ...api,
]

// Default export for backward compatibility (non-master view)
export default [...dashboard, ...summary, ...invoice, ...accountAndMember, ...report, ...settingLotto, ...fraudDetectionSingle, ...security, ...api/* , ...others */]
